import * as React from 'react'

function SvgImpregnationTop(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width={31} height={31} viewBox="0 0 4.329 4.329" {...props}>
			<g fill="currentColor">
				<path d="M2.874 1.721a.711.711 0 01-1.422 0c0-.392.711-1.35.711-1.35s.711.958.711 1.35z" />
				<path d="M1.105 3.854v-.891H.772v-.12h.8v.12H1.24v.89zM1.645 3.362q0-.251.135-.393.135-.143.349-.143.14 0 .252.067.112.067.17.187.06.119.06.27 0 .154-.062.275-.062.122-.176.184-.113.062-.245.062-.143 0-.255-.069-.112-.069-.17-.188t-.058-.252zm.138.002q0 .183.098.288.098.105.246.105.151 0 .248-.106.098-.106.098-.301 0-.124-.042-.215-.041-.093-.122-.143-.08-.05-.18-.05-.141 0-.244.097-.102.097-.102.325zM2.783 3.854v-1.01h.38q.101 0 .154.01.075.012.125.047.05.034.08.097.032.063.032.138 0 .129-.082.218-.082.09-.297.09h-.259v.41zm.133-.53h.261q.13 0 .184-.048t.055-.136q0-.063-.033-.108-.031-.046-.084-.06-.033-.009-.124-.009h-.259z" />
			</g>
		</svg>
	)
}

export default SvgImpregnationTop
